"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessScreenBase = void 0;
var react_1 = __importDefault(require("react"));
var WorkflowCard_1 = require("../../components/WorkflowCard");
var components_1 = require("../../components");
/**
 * Component that renders a success screen
 *
 * @param icon the icon to be displayed on the screen
 * @param messageTitle title of the success message
 * @param message success message to be displayed on the screen
 * @param dismissButtonLabel to display label for the button
 * @param canDismiss function to call when the dismiss button is clicked
 * @param onDismiss function to call when user clicks button
 * @param WorkflowCardBaseProps props that will be passed to the WorkflowCard component
 * @param WorkflowCardHeaderProps props that will be passed to the WorkflowCardHeader component
 * @param WorkflowCardInstructionProps props that will be passed to the WorkflowCardInstructions component
 * @param WorkflowCardActionsProps props that will be passed to the WorkflowCardActions component
 *
 * @category Component
 */
var SuccessScreenBase = function (props) {
    var icon = props.icon, _a = props.messageTitle, messageTitle = _a === void 0 ? '' : _a, _b = props.message, message = _b === void 0 ? '' : _b, _c = props.dismissButtonLabel, dismissButtonLabel = _c === void 0 ? '' : _c, canDismiss = props.canDismiss, onDismiss = props.onDismiss;
    var cardBaseProps = props.WorkflowCardBaseProps || {};
    var headerProps = props.WorkflowCardHeaderProps || {};
    var instructionsProps = props.WorkflowCardInstructionProps || {};
    var actionsProps = props.WorkflowCardActionsProps || {};
    return (react_1.default.createElement(WorkflowCard_1.WorkflowCard, __assign({}, cardBaseProps),
        react_1.default.createElement(WorkflowCard_1.WorkflowCardHeader, __assign({}, headerProps)),
        Object.keys(instructionsProps).length !== 0 && react_1.default.createElement(WorkflowCard_1.WorkflowCardInstructions, __assign({}, instructionsProps)),
        react_1.default.createElement(WorkflowCard_1.WorkflowCardBody, null,
            react_1.default.createElement(components_1.WorkflowFinishState, { icon: icon, title: messageTitle, description: message })),
        react_1.default.createElement(WorkflowCard_1.WorkflowCardActions, __assign({}, actionsProps, { nextLabel: dismissButtonLabel || actionsProps.nextLabel, canGoNext: canDismiss, onNext: function () {
                if (onDismiss)
                    onDismiss();
                if (actionsProps.onNext)
                    actionsProps.onNext();
            } }))));
};
exports.SuccessScreenBase = SuccessScreenBase;
